export const LOCATIONS = {
    "Kerala": {
      name: "Kerala",
      districts: [
        'Alappuzha', 'Ernakulam', 'Idukki', 'Kannur', 'Kasaragod', 'Kollam',
        'Kottayam', 'Kozhikode', 'Malappuram', 'Palakkad', 'Pathanamthitta',
        'Thiruvananthapuram', 'Thrissur', 'Wayanad'
      ]
    },
    "India": {
      name: "India",
      hasStates: true,
      states: {
        "Karnataka": ["Bangalore", "Bengaluru", "Mysuru", "Mangalore", "Hubli", "Belgaum", "Gulbarga", "Shimoga", "Tumakuru"],
        "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli", "Erode", "Vellore"],
        "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", "Kolhapur", "Solapur"],
        "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
        "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Kakinada"],
        "Delhi": ["New Delhi", "Delhi"],
        "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Siliguri", "Asansol"],
        "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar"],
        "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer", "Bikaner"],
        "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi", "Agra", "Allahabad", "Meerut"],
        "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
        "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam", "Alappuzha", "Malappuram"]
      }
    },
    "UAE": {
      name: "United Arab Emirates",
      districts: [
        'Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman', 'Al Ain', 'Ras Al Khaimah',
        'Fujairah', 'Umm Al Quwain', 'Dubai Marina', 'Deira', 'Bur Dubai',
        'Jumeirah', 'Palm Jumeirah', 'Dubai Silicon Oasis', 'Mirdif'
      ]
    },
    "Saudi Arabia": {
      name: "Saudi Arabia",
      districts: [
        'Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam', 'Al Khobar',
        'Dhahran', 'Jubail', 'Taif', 'Yanbu', 'Tabuk', 'Abha',
        'Khamis Mushait', 'Najran', 'Jizan', 'Al Qassim', 'Hail'
      ]
    },
    "Qatar": {
      name: "Qatar",
      districts: [
        'Doha', 'Al Wakrah', 'Al Khor', 'Umm Salal', 'Al Rayyan',
        'Lusail', 'The Pearl', 'West Bay', 'Old Airport', 'Ain Khaled',
        'Al Sadd', 'Msheireb', 'Al Gharafa', 'Al Waab'
      ]
    },
    "Kuwait": {
      name: "Kuwait",
      districts: [
        'Kuwait City', 'Hawalli', 'Salmiya', 'Ahmadi', 'Jahra',
        'Fahaheel', 'Mangaf', 'Sabah Al Salem', 'Farwaniya',
        'Khaitan', 'Abdullah Al Salem', 'Salwa', 'Rumaithiya'
      ]
    },
    "Bahrain": {
      name: "Bahrain",
      districts: [
        'Manama', 'Riffa', 'Muharraq', 'Hamad Town', 'A\'ali',
        'Isa Town', 'Saar', 'Budaiya', 'Seef', 'Tubli',
        'Diplomatic Area', 'Juffair', 'Amwaj Islands'
      ]
    },
    "Oman": {
      name: "Oman",
      districts: [
        'Muscat', 'Salalah', 'Sohar', 'Nizwa', 'Sur', 'Seeb',
        'Barka', 'Rustaq', 'Ibri', 'Al Buraimi', 'Duqm',
        'Muttrah', 'Ruwi', 'Al Amerat', 'Quriyat'
      ]
    },
    "Other": {
      name: "Other",
      districts: [],
      isOther: true  // Special flag: use custom text inputs
    }
  };